import api from './api';

// Admin API endpoints
export const devAdminAPI = {
    // Get all users (dedicated list endpoint)
    getUsers: (params = {}) => api.get('/api/v1/dev/users', { params }),

    // Get single user details
    getUserDetails: (userId) => api.get(`/api/v1/admin/users/${userId}`),

    // Delete user (using the fixed admin endpoint)
    deleteUser: (userId) => api.delete(`/api/v1/admin/users/${userId}`),

    // Delete pet (using specific admin endpoint for permission bypass)
    deletePet: (petId) => api.delete(`/api/v1/admin/pets/${petId}`),

    // Get active communities (optional, for future dashboard widgets)
    getActiveCommunities: () => api.get('/api/v1/admin/communities/active'),
};
